export const enterpriseAppsSectionMetaData = {
  id: 'enterpiseAppsSection',
  title: 'Cloud Fortified apps',
  description: "Cloud apps with additional security, reliability, and support to meet your organization's needs."
};